import React, { useState } from "react";

import Button from "../../Button";
import PutOnTransmitterImage from "src/assets/images/cgm/connection-journey/put-on-transmitter-thumbnail.png";
import VideoPlayerModal from "../../modals/common/VideoPlayerModal";
import { EXTERNAL_URLS } from "src/constants/common";

type PlaceTransmitterStepProps = {
  onContinue: () => void;
};

const PlaceTransmitterStep: React.FC<PlaceTransmitterStepProps> = ({
  onContinue,
}) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="px-4 py-4 flex flex-col items-center gap-4 w-full">
      <h1 className="text-2xl font-semibold text-black">
        Put on the transmitter
      </h1>
      <p className="text-sm text-gray-500 text-center">
        Watch the below video or follow the steps to put on your transmitter.
      </p>
      <div className="relative mt-10" onClick={() => setShowModal(true)}>
        <img
          src={PutOnTransmitterImage}
          alt="Put on Transmitter"
          className="w-full h-auto"
        />
      </div>

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-100">
        <Button
          onClick={onContinue}
          variant="contained"
          rounded="full"
          fullWidth
        >
          I have placed transmitter
        </Button>
      </div>

      <VideoPlayerModal
        show={showModal}
        title="How to Put on the Transmitter"
        handleClose={() => setShowModal(false)}
        videoUrl={EXTERNAL_URLS.CGM_HOW_TO_PUT_ON_TRANSMITTER}
        type="youtube"
      />
    </div>
  );
};

export default PlaceTransmitterStep;
